import { create } from './text.create.js';
import { italic, list } from './text.css.js';

const h1 = create('h1', 'display');
const h2 = create('h2', 'heading-large');
const h3 = create('h3', 'heading-medium');
const h4 = create('h4', 'heading-small');
const h5 = create('h5', 'body-large-strong');
const h6 = create('h6', 'body-medium-strong');
const p = create('p', 'body-medium');
const span = create('span', 'body-medium');
const div = create('div', 'body-medium');
const em = create('em', 'body-medium', italic);
const strong = create('strong', 'body-medium-strong');
const code = create('code', 'mono-medium');
const pre = create('pre', 'mono-medium');
const ul = create('ul', 'body-medium', list);
const ol = create('ol', 'body-medium', list);
/**
 * Renders a `<li>` with the variant inherited from its parent list. Setting an explicit
 * `variant` on the `<li>` overrides the inherited typography. Valid inside `Text.ul`, `Text.ol`,
 * or a plain `<ul>` / `<ol>` element.
 *
 * @compose { "parent": ["Text.ul", "Text.ol", "ul", "ol"], "multi": true }
 */
const li = create('li', 'body-medium');

export { code, div, em, h1, h2, h3, h4, h5, h6, li, ol, p, pre, span, strong, ul };
//# sourceMappingURL=text.js.map
